import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";

export type IReportSuffixesReturn = IAxiosReturn<string[]>;

/**
 * Retrieves the list of available report suffixes from the API.
 *
 * @param backEndUrl - The backend API base URL
 * @param _ - The unused parameter for data
 * @param controller - AbortController for request cancellation
 * @returns Promise resolving to report suffixes array or error information
 */
export const getReportSuffixes = async (
  backEndUrl: string,
  _: null,
  controller: AbortController,
): Promise<IReportSuffixesReturn> => {
  try {
    const response = await axios.get<string[]>(`${backEndUrl}Hierarchy/ReportSuffixes`, {
      signal: controller.signal,
    });
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Failed to retrieve report suffixes", error);
  }
};
